const layout = {
  sidebar: {
    minWidth: 60,
    maxWidth: 224,
  },
  header: {
    height: 0,
  },
  aside: {
    width: 261,
  },
};
export default layout;
